<template>
  <div class="NotfoundPage">
    <confirmation-banner
      icon-name="error"
      :title="$t('nofound.title', 'Oops, the page you requested can not be found')"
      :description="$t('nofound.subtitle', 'The page you are looking for has either been obsoleted or moved to a new location. Please go to the homepage by clicking the button below.')"
    />
    <div class="NotfoundPage_body">
      <div class="container">
        <router-link
          :to="RedirectToCart"
          class="AppButton back"
        >
          ‹ {{ $t('nofound.button', 'Back to homepage') }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
  import ConfirmationBanner from 'components/ConfirmationBanner'
  import { detectedCulture } from '@/utilities/common/culture'

  export default {
    name: 'not-found',

    components: {
      ConfirmationBanner
    },

    computed: {
      canadaLanguage () {
        return window.localStorage.getItem('canadaLanguage')
      },

      queryLanguage () {
        if (this.isCanadaSite) {
          if (this.canadaLanguage) {
            return this.canadaLanguage
          } else {
            return 'en-CA'
          }
        }
      },

      isCanadaSite () {
        return detectedCulture.code === 'en-ca'
      },

      RedirectToCart () {
        const lastBundle = window.localStorage.getItem('lastBundle')
        if (this.isCanadaSite) {
          return {
            path: '/checkout',
            query: {
              bundle: lastBundle,
              language: this.queryLanguage
            }
          }
        } else {
          return {
            path: '/checkout',
            query: {
              bundle: lastBundle
            }
          }
        }
      }
    }
  }
</script>

<style lang="scss">
  .NotfoundPage {
    &_header {
      color: #fff;
      font-size: .21rem;
      background-color: #0066a1;
      background-repeat: repeat-x;
      background-image: linear-gradient(to bottom right, #003655 0, #0066a1 50%, #0096ee 100%);

      .body {
        display: flex;
        justify-content: center;
        flex-direction: column;
        text-align: center;
        padding: .12rem .3rem .5rem;
        font-weight: 700;
        padding-top: .17rem;

        @include media(tablet) {
          padding-top: .17rem;
        }
      }
    }

    &_body {
      padding: .27rem 0 1rem;
      text-align: center;

      .back {
        background: $white;
        color: $blue;
        border: .01rem solid $blue;
        padding: .07rem .15rem;
        font-weight: 400;
        margin-bottom: .15rem;
      }

      @include media(tablet) {
        padding: .37rem 0 1.25rem;

        .AppButton {
          min-width: 3.55rem;
          order: 1;
        }
      }
    }
  }
</style>
